import { fieldConfig } from './configFields';

const ORDER_SUMMARY_OPTIONS = [
  {
    property: 'nametag',
    label: 'Button'
  },
  {
    property: 'email',
    label: 'Email'
  },
  {
    property: 'phone',
    label: 'Phone'
  },
  {
    property: 'address',
    label: 'Address'
  },
  {
    property: 'share',
    label: 'Include on roster',
    defaultValue: 'do not share'
  },
  {
    property: 'carpool',
    label: 'Share for carpool list',
    mapping: fieldConfig['carpool'].options
  },
  {
    property: 'volunteer',
    label: 'Volunteering',
    mapping: fieldConfig['volunteer'].options
  },
  {
    property: 'scholarship',
    label: 'Scholarship',
    mapping: fieldConfig['scholarship'].options
  },
  {
    property: 'tests',
    label: 'Covid Tests',
    mapping: fieldConfig['tests'].options
  },
  {
    property: 'comments',
    label: 'Comments'
  }
];

const config = { ORDER_SUMMARY_OPTIONS };
export default config;